import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  LOCALE_ID,
  OnInit,
  PLATFORM_ID,
  Signal,
  signal,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {PageMetaService} from '../../common/services/page-meta/page-meta.service';
import {FaqSectionComponent} from "./sections/faq-section/faq-section.component";
import {YouTubePlayer} from "@angular/youtube-player";
import {isPlatformBrowser, NgClass, NgOptimizedImage} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIcon, provideIcons} from "@ng-icons/core";
import {heroArrowLeft, heroArrowRight} from "@ng-icons/heroicons/outline";
import {catchError, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ContactApiService} from "../../api/contact/contact.api.service";


@Component({
  selector: 'app-donate-car-page',
  templateUrl: './donate-car-page.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    provideIcons({
      heroArrowLeft,
      heroArrowRight
    })
  ],
  imports: [
    FaqSectionComponent,
    YouTubePlayer,
    ReactiveFormsModule,
    NgClass,
    NgOptimizedImage,
    NgIcon,
  ],
  standalone: true
})
export class DonateCarPageComponent implements OnInit {
  readonly title: string = `Donate your Car to Ukraine – Support and Make an Impact`;
  readonly description: string = `Dozens of people across EU, UK and the US have donated their cars or sold them to buy cars Ukrainian soldiers need right now.`;
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly screenWidth = signal<number>(0);

  public readonly donateForm = new FormGroup({
    helpType: new FormControl<'0' | '1' | '2'>('0', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    name: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(3)]
    }),
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email]
    }),
    message: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
  })

  public selectedOption: string = '';
  public showSuccessAlert: boolean = false;
  public showErrorAlert: boolean = false;
  public readonly assetsPath: string = '/assets/images/home/stories/';
  public currentSlideIndex = 0;

  @ViewChild('donationForm')
  donationForm!: ElementRef<HTMLFormElement>;
  @ViewChild('scrollContainer', {static: false})
  scrollContainer!: ElementRef<HTMLDivElement>;

  public readonly articles: Array<{
    title: string,
    details: string,
    href: string,
    image: string
    videoId?: string;
  }> = [
    {
      title: 'From Australia to Lviv',
      details: `
        <p>To celebrate her 70-year-old anniversary Claire decided to drive 1,200 miles from UK to donate 4x4s to Ukrainian forces.</p>
`,
//       details: `
//         <p>To celebrate her 70-year-old anniversary Claire decided to drive 1,200 miles from UK to donate 4x4s to Ukrainian forces.</p>
//
// <p>Claire is an Australian vet and conservationist who has donated six pick-ups to the Ukrainian military but thought it's not enough and she should come to Ukraine in person. Forces News has made a story about her adventure.</p>
//
// <p>Since the start of the war in February 2022, Dr Claire Oelrichs has bought half a dozen pick-ups – paid for with her own money and through fundraising.</p>
//       `,
      href: 'https://youtu.be/dxH5qpn7KLs?si=a2RPQfhLy9lIwEdL',
      image: '',
      videoId: 'dxH5qpn7KLs',
    },
    {
      title: 'Adam from USA',
      details: `
        <p>Adam always wanted to help Ukraine with a tangible donation. In February 2023, he came to Donbas and personally donated two trucks to soldiers. </p>
`,
//       details: `
//         <p>Adam always wanted to help Ukraine with a tangible donation. In February 2023, he came to Donbas and personally donated two trucks to soldiers. </p>
//
// <p>Pickup trucks are versatile vehicles popular in rural areas of Britain. Today, many of them left their civilian lives to improve the mobility of the Ukrainian troops in the Donetsk region.</p>
//
// <p>United24 has followed one of the donors — Adam in his trip to frontline Kramatorsk to deliver the car he donated and find out his motivation and impressions after being this close to the frontline</p>
//       `,
      href: 'https://www.youtube.com/watch?v=z8pCibdfCkY',
      image: '',
      videoId: 'z8pCibdfCkY',
    },
    {
      title: 'British Business Bought us Truck',
      details: `
      <p>UK's dealership SUV Prestige has decided to contribute to the defence of Ukraine and purchased an L200 pickup.</p>
   `,
//       details: `
//       <p>UK's dealership SUV Prestige has decided to contribute to the defence of Ukraine and purchased an L200 pickup.</p>
//
// <p>After that Harry with his teammates organized a convoy to Lviv, creating a compelling story.</p>
//
// <p>This video is not only about how they traveled but also about the feelings and emotions of people as well as why they do what they do.</p>
//       `,
      href: 'https://youtu.be/G6rE1wfWpT8',
      image: '4-edward-and-hugh.jpg',
      videoId: 'G6rE1wfWpT8',
    },
    {
      title: 'Dutch and Germans come to rescue',
      details: `
      <p>A group of supporters from Germany and the Netherlands, led by Niels and Josh decided to scale up their efforts by organizing an entire convoy of cars to support Ukraine.</p>
`,
//       details: `
//       <p>A group of supporters from Germany and the Netherlands, led by Niels and Josh decided to scale up their efforts by organizing an entire convoy of cars to support Ukraine.</p>
//
// <p>They raised funds themselves and received some vehicles as direct donations. Together, they organized a convoy, delivering not only vital cars but also food, clothing, and other essential supplies.</p>
//
// <p>This mission perfectly combined the Dutch spirit of "having fun" with the German approach of "sticking to the schedule," resulting in a successful and impactful journey.</p>
//       `,
      href: 'https://www.youtube.com/watch?v=1YF1-5_MRlw',
      image: '2-martin-buhr.jpg',
      videoId: '1YF1-5_MRlw',
    },
  ];

  public currentArticle = this.articles[this.currentSlideIndex]

  private readonly localeId = inject(LOCALE_ID);
  private readonly contactApiService = inject(ContactApiService);
  private readonly httpClient = inject(HttpClient);

  public get currentLanguageCode(): string {
    return this.localeId[0] + this.localeId[1];
  }

  public pending: boolean = false;

  public readonly inquiries = {
    "0": {
      "title": `Buy a car (${this.currentLanguageCode})`
    },
    "1": {
      "title": `Donate a car (${this.currentLanguageCode})`
    },
    "2": {
      "title": `Sell a car with discount (${this.currentLanguageCode})`
    }
  };

  constructor(
    private pageMetaService: PageMetaService
  ) {
    this.pageMetaService.setTitleAndDescription({
      title: this.title,
      description: this.description
    });

    if (this.isBrowser) {
      this.screenWidth.set(window.innerWidth);
    }

  }

  public readonly playerWidth: Signal<number | undefined> = computed(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    if (this.screenWidth() < 400) {
      return 350;
    } else if (this.screenWidth() < 768) {
      return 410;
    } else if (isPortrait && this.screenWidth() >= 1024) {
      return 490;
    }
    return undefined;
  });

  public readonly playerHeight: Signal<number | undefined> = computed(() =>
    this.screenWidth() < 768 ? 360 : undefined
  );

  ngOnInit(): void {
    if (this.isBrowser) {
      window.addEventListener("resize", () => {
        this.screenWidth.set(window.innerWidth);
      });
    }
  }

  private startPending(): void {
    this.pending = true;
  }

  private stopPending(): void {
    this.pending = false;
  }

  public async submitForm(): Promise<void> {
    this.resetAlerts();
    this.startPending();
    this.donateForm.markAllAsTouched();
    if (this.donateForm.valid) {
      const {helpType, ...rest} = this.donateForm.getRawValue();
      const subject: string = this.inquiries[helpType].title;
      this.contactApiService.postDocument(JSON.stringify({
        ...rest,
        subject
      }))
        .pipe(
          catchError((error: HttpErrorResponse) => {
            this.stopPending();
            this.showErrorAlert = true;
            return throwError(() => error);
          })
        )
        .subscribe(() => {
          this.donateForm.reset();
          this.stopPending();
          this.showSuccessAlert = true;
        });
    } else {
      this.stopPending();
    }
  }

  private resetAlerts(): void {
    this.showSuccessAlert = false;
    this.showErrorAlert = false;
  }

  public selectOption(option: '0' | '1' | '2'): void {
    this.selectedOption = option;
    this.donateForm.patchValue({helpType: option});
    this.donationForm.nativeElement.scrollIntoView({behavior: 'smooth'});
  }


  public getHelpTypeClass(type: string) {
    const helpType = this.donateForm.get('helpType')?.value;
    return {
      'bg-[#2452DD] text-white': helpType === type,
      'text-mainColor bg-[#DDE2E7]': helpType !== type,
    };
  }

  public nextSlide(): void {
    if (this.currentSlideIndex < this.articles.length - 1) {
      this.currentSlideIndex++;
      this.updateCurrentArticle();
    }
  }

  public prevSlide(): void {
    if (this.currentSlideIndex > 0) {
      this.currentSlideIndex--;
      this.updateCurrentArticle();
    }
  }

  private updateCurrentArticle(): void {
    this.currentArticle = this.articles[this.currentSlideIndex];
    this.scrollToCurrentSlide();
  }

  public scrollToCurrentSlide() {
    const container = this.scrollContainer.nativeElement as HTMLDivElement;
    const slide = container.children.item(this.currentSlideIndex) as HTMLDivElement;
    container.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth'
    });
  }

  public getProgressPosition(): string {
    if (this.currentSlideIndex >= this.articles.length - 1) {
      return `calc(100% - 10%)`;
    }

    const progress = (this.currentSlideIndex / (this.articles.length - 1)) * 100;
    return `${progress}%`;
  }

}

export default DonateCarPageComponent;
